import { STANDARD_PERMISSION_CODES } from '../constants/authority.constants';

export const isStandardPermission = (prmCode: string): boolean => {
    return STANDARD_PERMISSION_CODES.includes(prmCode as (typeof STANDARD_PERMISSION_CODES)[number]);
};

export interface CommonCodeItem {
    comCode: string;
    comCdName: string;
    val1?: string;
    val2?: string;
    val3?: string;
    insDate?: string;
    insUser?: string;
    updDate?: string;
    updUser?: string;
}

export interface CommonCodeListResponse {
    codes: CommonCodeItem[];
}
